export { bg } from '@payloadcms/translations/languages/bg'
